import React from "react";
import { Text, View, ScrollView, KeyboardAvoidingView } from "react-native";

import appStyles from "../../../appStyles";
import ElementUsersList from "../users/ElementUsersList";
import AppTheme from "../../AppTheme";
import appPages from "../../../../appPages";

export default class ShareElementPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
    this.state = {
      initialSelection: null,
    };
  }

  getArgs() {
    if (this.controller.hasNavigation()) {
      return this.props.route.params?.args;
    } else {
      return this.controller.state.screenArgs?.args?.args;
    }
  }

  componentDidMount = async () => {
    if (this.controller.hasNavigation()) {
      this.focusListenerUnsub = this.props.navigation.addListener(
        "focus",
        () => {
          this.componentDidFocus();
        },
      );
    } else {
    }
  };

  componentWillUnmount = async () => {
    if (this.focusListenerUnsub) this.focusListenerUnsub();
  };

  componentDidFocus = async () => {
    this.setState((state) => ({
      initialSelection: (this.getArgs() || {}).selection,
    }));
  };

  onSaveComplete = (response) => {
    if (this.controller.hasNavigation() && this.controller.navigation) {
      this.controller.goBack();
    }

    const returnUrl = this.controller.getReturnUrl();
    const returnArgs = {};
    let returnPage = returnUrl || appPages.elementsPage;
    setTimeout(() => {
      this.controller.getItems("feed", returnPage, returnArgs);
    }, 100);
  };

  onSelectionDone = (selection) => {
    const { element } = this.getArgs() || {};

    const users = [];
    if (selection) {
      selection.forEach((u) => users.push(u.email));
    }
    const action = {
      action: "share",
      target: "element",
      id: element.edit_id,
      users: users,
    };

    this.controller.cardActionWithCallback(
      action,
      (data, response) => this.onSaveComplete(response),
      (error) => {
        if (error?.error) {
          this.setState((state) => ({
            ...state,
            mariMessage: {
              message: error.error,
              hasError: true,
            },
          }));
        }
      },
    );
  };

  render() {
    const { initialSelection } = this.state;

    return (
      <View
        style={[appStyles.container, { backgroundColor: AppTheme.containerBg }]}
      >
        <ElementUsersList
          controller={this.controller}
          onSelectionDone={this.onSelectionDone}
          initialSelection={initialSelection}
        />
      </View>
    );
  }
}
